<template>
  <div class="flex space-x-2 py-2 pl-3 rounded-lg border border-zinc-400 dark:border-zinc-600 hover:bg-zinc-50/5 text-sm">
    <IconSearch class="w-5 h-5 text-zinc-500" />
    <input class="w-full bg-transparent text-zinc-700 dark:text-zinc-50 placeholder:text-zinc-600 dark:placeholder:text-zinc-300 focus:outline-none" placeholder="Search" :value="modelValue" @input="event => $emit('update:modelValue', event.target.value)" />
  </div>
</template>

<script setup>
import IconSearch from "@/components/icons/IconSearch.vue";
defineProps({
  modelValue: String
});
defineEmits(["update:modelValue"]);
</script>
